import { useEffect, useState } from "react";

/**
 * Har `intervalMs` da yangilanadigan joriy vaqt (ms).
 *
 * "12 soniya oldin" kabi nisbiy matnlar uchun. Render ichida `Date.now()`
 * chaqirilmaydi: u toza emas va React Compiler bunday komponentni
 * tashlab ketadi. Vaqt holatda turadi va faqat taymer uni yangilaydi.
 */
export const useNow = (intervalMs = 1000): number => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
};
